import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-date-picker',
    standalone: false,
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent {
    date = new Date().toISOString();

    constructor(
        public glo: GlobalService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<DatePickerComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { leadId: string; email: string; name: string; clientType: string; clientSize: number },
    ) {}

    close() {
        this.dialogRef.close(this.date);
    }
}
